import React, { Component } from "react";
import styled from "styled-components";
import NewsImg from "@/assets/homePage/newsImg.png";

const Div = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 8rem 0 8rem 0;

  .news-title-container {
    width: 120rem;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .news-title {
      position: relative;
      font-size: 2.8rem;
      font-weight: bold;
      margin-bottom: 4.6rem;

      &::after {
        position: absolute;
        content: "";
        bottom: -1.6rem;
        left: 0;
        width: 6.4rem;
        height: 0.8rem;
        background-image: linear-gradient(to right, #1677ff, #31afff);
      }
    }

    .read-more {
      font-size: 1.4rem;
      color: #666666;
      cursor: pointer;
      position: relative;

      &::after {
        position: absolute;
        content: "";
        top: 0.4rem;
        right: -1rem;
        width: 1rem;
        height: 1rem;
        border-right: 1px solid #999999;
        border-top: 1px solid #999999;
        transform: rotate(45deg);
      }
    }
  }

  .news-content-container {
    width: 120rem;
    display: grid;
    grid-template-columns: 1fr 1fr;

    .img-container {
      width: 58.9rem;
      height: 39rem;
      background-image: ${(props) => `url(${props.newsImg})`};
      background-repeat: no-repeat;
      background-size: cover;
      display: flex;
      align-items: flex-end;

      .font {
        width: 100%;
        height: 6.6rem;
        line-height: 6.6rem;
        background-image: linear-gradient(
          to top,
          rgba(0, 0, 0, 0.4),
          rgba(0, 0, 0, 0)
        );
        font-size: 2.2rem;
        font-weight: bold;
        color: #ffffff;
        padding-left: 2.4rem;
      }
    }

    .news-container {
      display: grid;
      grid-template-rows: repeat(4, 1fr);
      grid-template-columns: 46rem;
      margin-left: 6.5rem;
      row-gap: 4.6rem;

      .news {
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .news-title {
          font-size: 2rem;
          color: #333333;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .news-time {
          font-size: 1.6rem;
          color: #919797;
        }
      }
    }
  }
`;

class NewsInformation extends Component {
  state = {
    newsDatas: [
      {
        newsTitle: "评标专家和评标专家库管理暂行办法",
        newsTime: "2021.09.24",
      },
      {
        newsTitle: "2020年上半年特种设备作业人员考核计划的通知",
        newsTime: "2021.09.10",
      },
      {
        newsTitle: "中华人民共和国招标投标法实施条例(2019年修订)",
        newsTime: "2021.09.24",
      },
      {
        newsTitle:
          "21年5月参加特种设备管理及作业中华人民共和国招标投标法实施条例",
        newsTime: "2021.09.10",
      },
    ],
  };

  render() {
    return (
      <Div newsImg={NewsImg}>
        <div className="news-title-container">
          <div className="news-title">要闻资讯</div>
          <div className="read-more">查看更多</div>
        </div>
        <div className="news-content-container">
          <div className="img-container">
            <div className="font">中国问诊、就诊方式的数字化转型</div>
          </div>
          <div className="news-container">
            {this.state.newsDatas.map((data, index) => (
              <div key={`news-${index}`} className="news">
                <div className="news-title">{data.newsTitle}</div>
                <div className="news-time">{data.newsTime}</div>
              </div>
            ))}
          </div>
        </div>
      </Div>
    );
  }
}

export default NewsInformation;
